import { StockItem, Product, Table, TaxRate, ModifierGroup, Section, Category, ExpenseCategory, Staff, AppSettings, Customer } from '../../types';
import { PERMISSIONS } from '../../constants';

export const getInitialData = (lang: string) => {
    // Helper to get translated string or fallback to English
    const isTr = lang.startsWith('tr');

    // --- 1. CATEGORIES ---
    const categories: Category[] = [
        { id: "hot_coffees", name: isTr ? "Sıcak Kahveler" : "Hot Coffees", sortOrder: 1 },
        { id: "cold_coffees", name: isTr ? "Soğuk Kahveler" : "Cold Coffees", sortOrder: 2 },
        { id: "desserts", name: isTr ? "Tatlılar" : "Desserts", sortOrder: 3 },
        { id: "snacks", name: isTr ? "Atıştırmalıklar" : "Snacks", sortOrder: 4 },
        { id: "barista_special", name: isTr ? "Özel" : "Specials", sortOrder: 5 }
    ];

    // --- 2. SECTIONS ---
    const sections: Section[] = [
        { id: 1, name: isTr ? 'Salon' : 'Main Hall' },
        { id: 2, name: isTr ? 'Bahçe' : 'Garden' },
        { id: 3, name: isTr ? 'Teras' : 'Terrace' }
    ];

    // --- 3. ROLES --- (kaldırıldı, permissions doğrudan Staff'ta)

    // --- 4. TAX RATES ---
    const taxRates: TaxRate[] = [
        { id: 1, name: isTr ? 'Gıda KDV' : 'Food Tax', rate: 1, description: '1%' },
        { id: 2, name: isTr ? 'İçecek KDV' : 'Drink Tax', rate: 10, description: '10%' },
        { id: 3, name: isTr ? 'Alkol KDV' : 'Alcohol Tax', rate: 20, description: '20%' },
    ];

    // --- 5. EXPENSE CATEGORIES ---
    const expenseCategories: ExpenseCategory[] = [
        { id: 1, name: isTr ? 'Kira' : 'Rent', description: '', defaultAmount: 15000 },
        { id: 2, name: isTr ? 'Elektrik' : 'Electricity', description: '' },
        { id: 3, name: isTr ? 'Su' : 'Water', description: '' },
        { id: 4, name: isTr ? 'Doğalgaz' : 'Gas/Heating', description: '' },
        { id: 5, name: isTr ? 'Personel Maaşı' : 'Salaries', description: '' },
        { id: 6, name: isTr ? 'Mutfak Alışverişi' : 'Kitchen Supplies', description: '' },
        { id: 7, name: isTr ? 'Vergi' : 'Taxes', description: '' },
        { id: 8, name: isTr ? 'Bakım Onarım' : 'Maintenance', description: '' },
        { id: 9, name: isTr ? 'Diğer' : 'Other', description: '' },
        { id: 10, name: isTr ? 'Zaiyat / Fire' : 'Wastage', description: '' }
    ];

    // --- 6. STOCK ITEMS ---
    const stockItems: StockItem[] = [
        { id: 1, name: isTr ? "Espresso Çekirdek" : "Espresso Beans", supplier: isTr ? "Kahve Dünyası" : "Premium Roasters", stock: 12.5, unit: "kg", percent: 65, cost: 350.00, img: "/assets/stock-espresso-beans.webp", criticalThreshold: 5, warningThreshold: 15 },
        { id: 2, name: "Colombia Supremo", supplier: "Global Bean", stock: 0.8, unit: "kg", percent: 15, cost: 480.00, img: "/assets/stock-colombia-beans.webp", critical: true, criticalThreshold: 2, warningThreshold: 5 },
        { id: 3, name: isTr ? "Tam Yağlı Süt" : "Whole Milk", supplier: "Local Farm", stock: 45, unit: "L", percent: 80, cost: 32.50, img: "/assets/stock-milk.jfif", criticalThreshold: 10, warningThreshold: 25 },
        { id: 4, name: isTr ? "Vanilya Şurubu" : "Vanilla Syrup", supplier: "Monin", stock: 5, unit: "L", percent: 45, cost: 350.00, img: "/assets/stock-vanilla.webp", criticalThreshold: 2, warningThreshold: 5 },
        { id: 5, name: isTr ? "Yulaf Sütü" : "Oat Milk", supplier: "Alpro", stock: 12, unit: "L", percent: 100, cost: 65.00, img: "/assets/stock-oat-milk.webp", criticalThreshold: 5, warningThreshold: 10 },
        { id: 6, name: isTr ? "Badem Sütü" : "Almond Milk", supplier: "Alpro", stock: 8, unit: "L", percent: 100, cost: 75.00, img: "/assets/stock-almond-milk.webp", criticalThreshold: 3, warningThreshold: 5 },
        { id: 7, name: isTr ? "Laktozsuz Süt" : "Lactose Free Milk", supplier: isTr ? "İçim" : "Fresh Dairy Co.", stock: 15, unit: "L", percent: 100, cost: 38.00, img: "/assets/stock-lactose-free.webp", criticalThreshold: 5, warningThreshold: 10 },
        { id: 8, name: isTr ? "Karamel Şurubu" : "Caramel Syrup", supplier: "Monin", stock: 3, unit: "L", percent: 100, cost: 350.00, img: "/assets/stock-caramel.jfif", criticalThreshold: 1, warningThreshold: 2 },
        { id: 9, name: isTr ? "Fındık Şurubu" : "Hazelnut Syrup", supplier: "Monin", stock: 2, unit: "L", percent: 100, cost: 350.00, img: "/assets/stock-hazelnut.jfif", criticalThreshold: 1, warningThreshold: 2 },
        { id: 10, name: isTr ? "Kafeinsiz Çekirdek" : "Decaf Beans", supplier: isTr ? "Kahve Dünyası" : "Premium Roasters", stock: 2, unit: "kg", percent: 100, cost: 400.00, img: "/assets/stock-decaf.webp", criticalThreshold: 1, warningThreshold: 2 },
        { id: 11, name: isTr ? "Sıvı Krema" : "Liquid Cream", supplier: isTr ? "Tikveşli" : "Cream & Co.", stock: 10, unit: "L", percent: 100, cost: 120.00, img: "/assets/stock-cream.jfif", criticalThreshold: 2, warningThreshold: 5 }
    ];

    // --- 7. MODIFIER GROUPS ---
    const modifierGroups: ModifierGroup[] = [
        {
            id: 1,
            name: isTr ? 'Sıcaklık' : 'Temperature',
            allowMultiple: false,
            options: [
                { id: 'temp_hot', name: isTr ? 'Sıcak' : 'Hot', price: 0 },
                { id: 'temp_iced', name: isTr ? 'Buzlu' : 'Iced', price: 5 }
            ]
        },
        {
            id: 2,
            name: isTr ? 'Süt Seçimi' : 'Milk Choice',
            allowMultiple: false,
            options: [
                { id: 'milk_whole', name: isTr ? 'Tam Yağlı' : 'Whole Milk', price: 0, stockId: 3, amount: 0.25 },
                { id: 'milk_oat', name: isTr ? 'Yulaf Sütü' : 'Oat Milk', price: 20, stockId: 5, amount: 0.25 },
                { id: 'milk_almond', name: isTr ? 'Badem Sütü' : 'Almond Milk', price: 25, stockId: 6, amount: 0.25 },
                { id: 'milk_lactose_free', name: isTr ? 'Laktozsuz' : 'Lactose Free', price: 10, stockId: 7, amount: 0.25 },
            ]
        },
        {
            id: 3,
            name: isTr ? 'Şurup / Aroma' : 'Syrup / Flavor',
            allowMultiple: false,
            options: [
                { id: 'syrup_none', name: isTr ? 'İstemiyorum' : 'None', price: 0 },
                { id: 'syrup_vanilla', name: isTr ? 'Vanilya' : 'Vanilla', price: 15, stockId: 4, amount: 0.02 },
                { id: 'syrup_caramel', name: isTr ? 'Karamel' : 'Caramel', price: 15, stockId: 8, amount: 0.02 },
                { id: 'syrup_hazelnut', name: isTr ? 'Fındık' : 'Hazelnut', price: 15, stockId: 9, amount: 0.02 },
            ]
        },
        {
            id: 4,
            name: isTr ? 'Ekstralar' : 'Extras',
            allowMultiple: true,
            options: [
                { id: 'extra_shot', name: 'Extra Shot', price: 30, stockId: 1, amount: 0.018 },
                { id: 'extra_decaf', name: isTr ? 'Kafeinsiz' : 'Decaf', price: 0, stockId: 10, amount: 0.018 },
                { id: 'extra_cream', name: isTr ? 'Krema' : 'Cream', price: 10, stockId: 11, amount: 0.05 },
            ]
        }
    ];

    // --- 8. PRODUCTS ---
    const products: Product[] = [
        {
            id: 1,
            name: "Iced Latte",
            category: "cold_coffees",
            price: 85.00,
            image: "/assets/prod-iced-latte.webp",
            stock: 45,
            description: isTr ? "Espresso, soğuk süt ve buz parçacıkları." : "Espresso, cold milk and ice.",
            customizable: true,
            recipe: [{ stockId: 1, amount: 0.018 }, { stockId: 3, amount: 0.25 }]
        },
        {
            id: 2,
            name: "San Sebastian",
            category: "desserts",
            price: 140.00,
            image: "/assets/prod-san-sebastian.webp",
            stock: 12,
            description: isTr ? "Çikolata soslu, yumuşak dokulu." : "Soft texture with chocolate sauce."
        },
        {
            id: 3,
            name: "Caffè Latte",
            category: "hot_coffees",
            price: 75.00,
            image: "/assets/prod-latte.webp",
            stock: 120,
            description: isTr ? "Zengin espresso ve kadifemsi süt." : "Rich espresso and velvety milk.",
            customizable: true,
            recipe: [{ stockId: 1, amount: 0.018 }, { stockId: 3, amount: 0.22 }]
        },
        {
            id: 4,
            name: "Americano",
            category: "hot_coffees",
            price: 65.00,
            image: "/assets/prod-americano.webp",
            stock: 999,
            description: isTr ? "Sıcak su ile inceltilmiş espresso." : "Espresso diluted with hot water.",
            customizable: true,
            recipe: [{ stockId: 1, amount: 0.018 }]
        },
        {
            id: 5,
            name: "Tiramisu",
            category: "desserts",
            price: 120.00,
            image: "/assets/prod-tiramisu.webp",
            stock: 8,
            description: isTr ? "İtalyan klasiği." : "Italian classic."
        },
        {
            id: 6,
            name: "Kruvasan",
            category: "snacks",
            price: 55.00,
            image: "/assets/prod-croissant.webp",
            stock: 0,
            description: isTr ? "Tereyağlı taze kruvasan." : "Fresh butter croissant."
        },
        {
            id: 7,
            name: "Cappuccino",
            category: "hot_coffees",
            price: 95.00,
            image: "/assets/prod-cappuccino.webp",
            stock: 50,
            description: isTr ? "Eşit oranlı espresso, süt ve köpük." : "Equal parts espresso, milk and foam.",
            customizable: true,
            recipe: [{ stockId: 1, amount: 0.018 }, { stockId: 3, amount: 0.18 }]
        },
        {
            id: 8,
            name: "Cold Brew",
            category: "cold_coffees",
            price: 95.00,
            image: "/assets/prod-coldbrew.webp",
            stock: 20,
            description: isTr ? "12 saat demlenmiş soğuk kahve." : "12-hour brewed cold coffee.",
            customizable: true,
            recipe: [{ stockId: 2, amount: 0.045 }]
        }
    ];

    // --- 9. TABLES ---
    const tables: Table[] = Array.from({ length: 12 }, (_, i) => {
        let section = isTr ? 'Salon' : 'Main Hall';
        if (i >= 4 && i < 8) section = isTr ? 'Bahçe' : 'Garden';
        if (i >= 8) section = isTr ? 'Teras' : 'Terrace';

        return {
            id: i + 1,
            name: `${isTr ? 'Masa' : 'Table'} ${i + 1}`,
            section,
            status: 'empty',
            capacity: (i % 2 === 0) ? 4 : 2
        };
    });

    // --- 10. STAFF ---
    const allPerms = PERMISSIONS.map(p => p.key);
    const staff: Staff[] = [
        { id: 1, name: isTr ? 'Yönetici' : 'Manager', status: 'working', phone: '', avatar: "/assets/staff-1.webp", dailySales: 0, pinCode: '1234', permissions: allPerms, isAdmin: true },
        { id: 2, name: 'Alex', status: 'working', phone: '', avatar: "/assets/staff-2.webp", dailySales: 0, pinCode: '0000', permissions: ['VIEW_TABLES', 'MANAGE_STOCK'] },
        { id: 3, name: 'Sam', status: 'off', phone: '', avatar: "/assets/staff-3.webp", dailySales: 0, permissions: ['VIEW_TABLES'] },
        { id: 4, name: 'Chef', status: 'working', phone: '', avatar: "/assets/staff-4.webp", dailySales: 0, permissions: ['MANAGE_STOCK'] }
    ];

    // --- 11. APP SETTINGS ---
    const settings: AppSettings = {
        appName: 'KahveInn',
        appAddress: isTr ? 'Butik Kahve Evi' : 'Boutique Coffee House',
        isSetupComplete: false,
        autoZReport: false,
        autoShiftReport: false,
        workingHoursStart: 8,
        workingHoursEnd: 23,
        taxStrategy: 'inclusive',
        currencySymbol: isTr ? '₺' : '$',
        uiScale: 100,
        subscription: {
            plan: 'trial',
            status: 'active',
            nextBillingDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString()
        },
        reportSettings: {
            showStockCost: false,
            showWastageLoss: false,
            operationalMode: false,
            showNetRevenue: false
        }
    };

    // --- 12. CUSTOMERS ---
    const customers: Customer[] = [
        { id: "1", name: 'Ayşe Demir', phone: '0555 123 45 67', email: 'ayse@example.com', totalSpent: 0, debt: 0, lastVisit: isTr ? '2023-11-20' : '2023-11-20' },
        { id: "2", name: 'Mehmet Yılmaz', phone: '0532 987 65 43', email: 'mehmet@example.com', totalSpent: 0, debt: 0 },
        { id: "3", name: 'Zeynep Kaya', phone: '0544 555 44 22', totalSpent: 0, debt: 0 },
    ];

    return {
        categories,
        sections,
        taxRates,
        expenseCategories,
        stockItems,
        modifierGroups,
        products,
        tables,
        staff,
        settings,
        customers
    };
};

